import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, Link } from "react-router-dom";

import app from "../../../firebase-config";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import { version } from "../../../Version";

function Login() {
  const navigate = useNavigate();

  const [showPass, setShowPass] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [loading, setLoading] = useState(false);

  const logo = "./assets/logo.png";
  const iconG = "./assets/google-icon.png";

  const provider = new firebase.auth.GoogleAuthProvider();
  const crearUsuarioAuth = app.functions().httpsCallable("crearUsuarioAuth");

  // ---------------------------
  // 🔵 LOGIN CON GOOGLE
  // ---------------------------
  async function loginGoogle() {
    app
      .auth()
      .signInWithPopup(provider)
      .then(async (result) => {
        const user = result.user;

        const usuario = await app
          .firestore()
          .collection("users")
          .doc(user.uid)
          .get();

        if (usuario.exists) {
          localStorage.setItem("usuarioToken", true);
          navigate("/", { replace: true });
        } else {
          navigate("/registro", { replace: true });
        }
      })
      .catch((error) => console.log(error));
  }

  // ---------------------------
  // 🔵 LOGIN CON CORREO Y CONTRASEÑA
  // ---------------------------
  async function loginUser(event) {
    event.preventDefault();
    setLoading(true);

    const { email, password } = event.target.elements;

    const emailVal = email.value.trim().toLowerCase();
    const passVal = password.value;
    setErrorMsg(false);

    // Validación de email
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;

    if (!emailRegex.test(emailVal)) {
      setLoading(false);
      setErrorMsg(true);
      return;
    }

    app
      .auth()
      .signInWithEmailAndPassword(emailVal, passVal)
      .then(() => {
        localStorage.setItem("usuarioToken", true);
        navigate("/", { replace: true });
      })
      .catch(() => {
        // Revisar si el usuario existe para recuperación
        app
          .firestore()
          .collection("users")
          .where("email", "==", emailVal)
          .get()
          .then((snap) => {
            if (!snap.empty) {
              let idUser = "";
              snap.forEach((doc) => {
                idUser = doc.data().idUserAuth;
              });

              crearUsuarioAuth({
                idUserAuth: idUser,
                email: emailVal,
                password: "*1nvalid_pAss_to_be_recovered*",
              })
                .then(() => {
                  app.auth().signOut();
                  localStorage.clear();
                  localStorage.setItem("email", emailVal);
                  navigate("/existente", { replace: true });
                })
                .catch(() => {
                  setErrorMsg(true);
                  setLoading(false);
                });
            } else {
              setLoading(false);
              setErrorMsg(true);
            }
          });
      });
  }

  const togglePassword = () => setShowPass((p) => !p);

  useEffect(() => {
    localStorage.clear();
  }, []);

  // ---------------------------
  // 🔵 HTML (PORTAL)
  // ---------------------------
  const node = (
    <div className="hold-transition login-page">
      <div className="login-box">
        <div className="login-logo">
          <img alt="" src={logo} style={{ width: 120 }} />
        </div>

        <div className="card">
          <div className="card-body login-card-body">
            <div className="login-logo" style={{ color: "#0B3688" }}>
              <b>Iniciar Sesión</b>
            </div>

            <p className="login-box-msg">
              Bienvenido a Storm Alert, por favor ingrese con los datos de su
              cuenta personal.
            </p>

            {/* 🔹 Form login */}
            <form onSubmit={loginUser}>
              <div className="input-group mb-3">
                <input
                  name="email"
                  className="form-control"
                  placeholder="Correo electrónico"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="far fa-id-card" />
                  </div>
                </div>
              </div>

              <div className="input-group mb-3">
                <input
                  name="password"
                  type={showPass ? "text" : "password"}
                  className="form-control"
                  placeholder="Contraseña"
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span
                      onClick={togglePassword}
                      style={{ cursor: "pointer" }}
                      className={
                        showPass ? "fas fa-eye-slash" : "fas fa-eye"
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="row mx-auto">
                {errorMsg && (
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <p className="mb-1" style={{ color: "red" }}>
                      Ingrese un correo registrado, compruebe que la contraseña
                      sea mayor a 6 caracteres.
                    </p>
                  </div>
                )}

                {loading && <div>Cargando...</div>}

                <div className="col-12" style={{ textAlign: "center" }}>
                  <p className="mb-1">
                    <Link to="/recuperar">¿Olvidaste tu contraseña?</Link>
                  </p>
                </div>

                <div className="col-10 m-2 mx-auto">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    style={{
                      background: "#0B3688",
                      border: "#0B3688",
                    }}
                  >
                    Iniciar Sesión
                  </button>
                </div>
              </div>
            </form>

            {/* 🔹 Login con Google */}
            <div className="col-10 m-2 mx-auto">
              <button
                onClick={loginGoogle}
                className="btn btn-primary btn-block shadow"
                style={{
                  background: "rgb(255,255,255)",
                  borderColor: "rgba(0,0,0,0.2)",
                }}
              >
                <img
                  alt=""
                  src={iconG}
                  className="mr-3 mb-1"
                  style={{ width: 20 }}
                />
                <span style={{ color: "rgba(0,0,0,0.8)" }}>
                  Iniciar Sesión con Google
                </span>
              </button>
            </div>

            <br />
            <br />
          </div>

          {/* Footer */}
          <div className="card-footer" style={{ textAlign: "center" }}>
            ({version}) ©{new Date().getFullYear()} - By Centinela S&I
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(node, document.getElementById("login"));
}

export default Login;
